import { DefaultButton } from "@fluentui/react";
import styles from './index.module.sass';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
interface SampleProfileCardProps {
    sampleProfileId: number;
    imgHeaderSource: string;
    cardTitle: string;
    cardPrice: string;
    cardBody: string;
    cardJsonFundsData: any;
}

interface IJsonFundsData {
    Funds: any[]
    Riesgo: string
    Rentabilidad: number
    Volatilidad: number
    FechaInicio: string
    PortfolioFinametrixId: string
    RiskProfileId: string
}

const SampleProfileCard = (props: SampleProfileCardProps) => {
    const history = useHistory();

    const {
        sampleProfileId,
        cardTitle,
        cardPrice,
        cardBody,
        imgHeaderSource,
        cardJsonFundsData
    } = props;

    const [jsonFundsData, setJsonFundsData] = useState<IJsonFundsData | null>(null);

    const formatPrice = (price: string): string => {
        const numericPrice = parseFloat(price);
        return numericPrice
            .toFixed(2)
            .replace('.', ',')
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    useEffect(() => {
        if (cardJsonFundsData) {
            try {
                const parsed = typeof cardJsonFundsData === 'string'
                    ? JSON.parse(cardJsonFundsData)
                    : cardJsonFundsData;
                setJsonFundsData(parsed);
            } catch (err) {
                console.error("Error parsing jsonFundsData:", err);
            }
        }
    }, [cardJsonFundsData]);



    useEffect(() => {
        console.log('jsonFundsData', jsonFundsData);
    }, [jsonFundsData]);

    return (
        <div className={styles.card}>
            <div className={styles.imageCardContent}>
                <img
                    src={'https://ironiaimg.blob.core.windows.net/imagen/' + imgHeaderSource}
                    alt={cardTitle}
                    className={styles.img}
                />
            </div>
            <div className={`${styles.cardContent} card-content`}>
                <div className={`${styles.cardTitle} card-title`}>{cardTitle}</div>
                <div className={`${styles.cardBody} card-body`}>{cardBody}</div>
                <div className={`${styles.cardPrice} card-price`}>
                    <span>{formatPrice(cardPrice)} €</span>
                </div>

                {jsonFundsData && (
                    <div className={`${styles.cardRentability} card-rentability`}>
                        <span>Nivel de riesgo: {jsonFundsData.Riesgo}</span>
                        <span>Rentabilidad bruta: {jsonFundsData.Rentabilidad} %</span>
                        <span>Cálculo realizado desde hace un año hasta hoy.</span>
                        {/* {jsonFundsData.FechaInicio} */}
                    </div>
                )}

                <DefaultButton
                    className={`${styles.button} button tiny-secondary-button`}
                    onClick={() => { history.push(`/savingsPlans/sampleProfiles/sampleProfile/${sampleProfileId}`) }}
                >
                    Seleccionar
                </DefaultButton>
            </div>
        </div>
    );
}

export default SampleProfileCard;